import React, { useEffect, useRef, lazy } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, StarIcon, DownloadIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function HeroSection() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const cartUrl = 'https://competirsinmiedo.com/cart/add?id=45092891263029&quantity=1';
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    const timer = setTimeout(() => {
      video.src = 'https://cdn.magicpatterns.com/uploads/b6ssMGLKuoeiXiQFBmiu3j/copy_A61BCB96-EA7B-4CF1-89CB-D97AE75A0533.mov';
      video.load();
    }, 100);
    return () => clearTimeout(timer);
  }, []);
  return <section className="relative py-20 md:py-28 overflow-hidden bg-[#1a1a2e]" data-id="element-94">
      <video ref={videoRef} autoPlay loop muted playsInline preload="none" className="absolute inset-0 w-full h-full object-cover opacity-40 mix-blend-overlay" data-id="element-95" />

      <div className="max-w-5xl mx-auto px-5 sm:px-6 lg:px-8 relative z-10" data-id="element-96">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-97">
          <motion.div initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.4
        }} className="text-center lg:text-left" data-id="element-98">
            <div className="inline-flex items-center px-3 py-1 rounded-full bg-white/10 backdrop-blur-sm text-white font-medium mb-4 border border-white/20 text-xs tracking-wide uppercase" data-id="element-99">
              <StarIcon className="inline w-3 h-3 fill-brand-amber text-brand-amber mr-1.5" data-id="element-100" />
              Para familias y futbolistas jóvenes
            </div>

            <p className="text-white/70 italic mb-6 text-sm" data-id="element-101">
              Porque creemos en la pasión del deporte y en la fortaleza del
              poder juvenil
            </p>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading text-white mb-6 leading-[1.1]" data-id="element-102">
              Ayuda a tu hijo a jugar sin miedo y volver a disfrutar del fútbol{' '}
              <span className="text-brand-amber" data-id="element-103">en 14 días</span>
            </h1>

            <p className="text-base md:text-lg text-white/80 mb-8 leading-relaxed" data-id="element-104">
              Si tu hijo entrena bien, pero en los partidos se bloquea, pierde
              confianza o juega con miedo al error, esta guía fue creada para
              ayudarlo a volver a competir con seguridad.
            </p>

            <div className="flex flex-col items-center lg:items-start space-y-6" data-id="element-105">
              <p className="tracking-wide uppercase text-xs font-[800] text-[#D70000]" data-id="element-106">
                ¡AYÚDALO ANTES DE SU PRÓXIMO JUEGO!
              </p>

              <div className="flex flex-col sm:flex-row items-center space-y-3 sm:space-y-0 sm:space-x-6 text-sm text-white/80" data-id="element-107">
                <div className="flex items-center" data-id="element-108">
                  <ShieldCheckIcon className="w-4 h-4 text-white/60 mr-1.5" data-id="element-109" />
                  <span data-id="element-110">Pago Seguro</span>
                </div>
                <div className="flex items-center" data-id="element-111">
                  <DownloadIcon className="w-4 h-4 text-white/60 mr-1.5" data-id="element-112" />
                  <span data-id="element-113">Acceso Inmediato</span>
                </div>
                <div className="flex items-center" data-id="element-114">
                  <div className="flex mr-1.5" data-id="element-115">
                    {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="w-3.5 h-3.5 fill-brand-amber text-brand-amber" data-id="element-116" />)}
                  </div>
                  <span data-id="element-117">+3,200 Familias</span>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.4,
          delay: 0.1
        }} className="relative mx-auto w-full max-w-md" data-id="element-118">
            <img src="https://cdn.magicpatterns.com/uploads/9JDoySjskcLgTNnRbeBdQK/WhatsApp_Image_2026-03-31_at_00.12.25.jpg" alt="Competir Sin Miedo — Programa de fortaleza mental para futbolistas y familias" className="w-full h-auto rounded-2xl shadow-sm border border-white/10" loading="lazy" data-id="element-119" />

            <div className="absolute -bottom-4 -right-4 sm:-bottom-6 sm:-right-6 bg-white p-4 rounded-2xl shadow-sm border border-gray-100" data-id="element-120">
              <div className="text-brand-slate font-bold text-lg md:text-xl" data-id="element-121">
                +9 Bonos
              </div>
              <div className="text-xs text-brand-slate-muted uppercase tracking-wide mt-0.5" data-id="element-122">
                Incluidos Hoy
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}